/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});

 //  function getQueryStringParameters() {
 //     var parameters = {}, hash;
 //     var q = document.URL.split('?')[1];
 //     if(q != undefined) {
 //         q = q.split('&');
 //         for(var i = 0; i < q.length; i++) {
 //             hash = q[i].split('=');
 //             parameters[hash[0]] = hash[1];
 //         }
 //     }
 //     return parameters;
 // }

//   function getQueryStringParameters() {
//     var parameters = {}, hash;
//     var q = document.URL.split('?')[1];
//     if (q != undefined) {
//         q = q.split('&');
//         for (var i = 0; i < q.length; i++) {
//             hash = q[i].split('=');
//             // If the parameter is 'page', keep the first occurrence
//             if (hash[0] === 'page' && parameters['page'] === undefined) {
//                 parameters[hash[0]] = hash[1];
//             } else if (hash[0] !== 'page') {
//                 parameters[hash[0]] = hash[1];
//             }
//         }
//     }
//     return parameters;
// }
  
// function isEmpty(obj) {
//  for(var key in obj) {
//  if(obj.hasOwnProperty(key))
//  return false;
//  }
//  return true;
// }

function getQueryStringParameters() {
    var parameters = {}, hash;
    var q = document.URL.split('?')[1];
    if (q != undefined) {
        q = q.split('&');
        for (var i = 0; i < q.length; i++) {
            hash = q[i].split('=');
            if (hash[0] === 'page' && !parameters['page']) {
                parameters[hash[0]] = hash[1];
            } else if (hash[0] !== 'page') {
                parameters[hash[0]] = hash[1];
            }
        }
    }
    return parameters;
}

function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}
function getQueryStringParametersFromUrl(url) {
    var parameters = {}, hash;
    var q = url.split('?')[1];
    if (q != undefined) {
        q = q.split('&');
        for (var i = 0; i < q.length; i++) {
            hash = q[i].split('=');
            parameters[hash[0]] = hash[1];
        }
    }
    return parameters;
}


  
  $(document).ready(function() {
    // $('a').click(function(event) {
    //   var targetUrl = $(this).attr('href'); // Get the target URL from the clicked link
    //   var currentParams = getQueryStringParameters(); // Get current query parameters

    //   if (!isEmpty(currentParams)  && currentParams.hasOwnProperty('utm_source')) {
    //       // Append current query parameters to the target URL
    //       if (targetUrl.indexOf('?utm_source') !== -1) {
    //           targetUrl += '&utm_source' + $.param(currentParams);
    //       } else {
    //           targetUrl += '?' + $.param(currentParams);
    //       }
    //   }

    //   // Update the link's href attribute to include the query parameters
    //   $(this).attr('href', targetUrl);
    // });

   $('a').click(function(event) {
    var targetUrl = $(this).attr('href'); // Get the target URL from the clicked link
    var currentParams = getQueryStringParameters(); // Get current query parameters

    if (!isEmpty(currentParams) && currentParams.hasOwnProperty('utm_source')) {
        var newParams = {};
        // Ensure only one 'page' parameter is kept
        if (currentParams['page']) {
            newParams['page'] = currentParams['page'];
        }
        for (var key in currentParams) {
            if (key !== 'page') {
                newParams[key] = currentParams[key];
            }
        }

        // Parse target URL parameters
        var targetParams = {};
        var urlParts = targetUrl.split('?');
        if (urlParts.length > 1) {
            targetParams = getQueryStringParametersFromUrl(targetUrl);
        }

        // Merge currentParams and targetParams, prioritizing targetParams
        var mergedParams = { ...newParams, ...targetParams };

        // Reconstruct the target URL with merged parameters
        targetUrl = urlParts[0] + '?' + $.param(mergedParams);
    }

    // Update the link's href attribute to include the query parameters
    $(this).attr('href', targetUrl);
});

    
  });
})();


